import * as API from 'core/api';
import { Message } from 'core/ui-next/modal';
import { RestaurantFacade } from 'pos/facades';
import * as SalesStore from 'pos/modules/main/SalesStore';

export default async function applyOffer({ offerId }: { offerId: number }): Promise<void> {
	const ticket = SalesStore.getTicket();
	const offers = await RestaurantFacade.getOffers(ticket.Id);

	const offerToApply = offers.find(x => x.Id === offerId);
	if (!offerToApply) {
		await Message.show(API.Res.Msg.MSG_INVALID_OFFER());
		return;
	}

	await SalesStore.setOffers([...ticket.Offers, offerToApply]);
}